import React from "react";
import * as S from "./styles";
import { NavLinkProps } from "react-router-dom";

interface CustomProps {
  children: React.ReactNode;
  isNavLink?: never;
}

type CommonButton = {
  isNavLink: false;
} & React.HTMLProps<HTMLButtonElement>;

type MyNavLinkProps = {
  isNavLink: true;
  to: string;
} & NavLinkProps;

type NeonProps = CustomProps | CommonButton | MyNavLinkProps;

export default function NeonButton({
  children,
  isNavLink,
  ...props
}: NeonProps) {
  if (isNavLink) {
    const navLinkProps = props as MyNavLinkProps;
    // @ts-ignore
    return <S.NavLinkStyled {...navLinkProps}>{children}</S.NavLinkStyled>;
  }

  const buttonProps = props as React.ButtonHTMLAttributes<HTMLButtonElement>;
  // @ts-ignore
  return <S.BtnStyled {...buttonProps}>{children}</S.BtnStyled>;
}
